// @flow
import React, { Component } from "react";
import type { FieldProps } from "redux-form";
import Dropzone from "react-dropzone";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { withStyles } from "@material-ui/core";
import FormHelperText from "@material-ui/core/FormHelperText";
import styles from "../styles/styles";

type Props = {
    classes: Object,
} & FieldProps;

type State = {
    rejected: Array<File>,
    error?: ?string,
};

class DropzoneWithPreview extends Component<Props, State> {
    constructor(props) {
        super(props);
        this.state = {
            rejected: [],
            error: null,
        };
    }

    componentWillUnmount() {
        // Make sure to revoke the data uris to avoid memory leaks
        // this.props.input.value.forEach(file => URL.revokeObjectURL(file.preview));
    }

    handleRemove = (name: string) => {
        const { input } = this.props;
        const { onChange, value } = input;

        const arr = value.filter(item => item.file.name !== name);
        this.setState({ error: null });
        return onChange(arr);
    };

    handleChange = (
        event: Array<SyntheticEvent<HTMLInputElement>>,
        rejectedFiles: Array<File>
    ) => {
        const { input } = this.props;
        this.setState({ error: null, rejected: rejectedFiles });
        const { onChange, value } = input;
        if (value.length <= 3) {
            const files = []; //= event.splice(0, 3 - value.length).map(item => ({ file: item }));
            for (let i = 0; i < 3 - value.length; i += 1) {
                let alreadyExists = false;
                if (event[i] != null) {
                    if (value.length > 0) {
                        // $FlowFixMe
                        const items = value.filter(
                            item => item.file.name === event[i].name
                        );
                        alreadyExists = items.length > 0;
                        if (!alreadyExists) {
                            files.push({ file: event[i] });
                        }
                    } else {
                        files.push({ file: event[i] });
                    }
                }
            }
            const arr = [...value, ...files];
            onChange(arr);
        }
        if (value.length === 3 && event.length > 0) {
            this.setState({
                error: "Vous pouvez télécharger jusqu'à 3 images",
            });
        }
    };

    render() {
        const {
            input,
            classes,
            meta: { error },
        } = this.props;
        const { rejected, error: stateError } = this.state;
        const { value } = input;

        let thumbs = [];
        if (value && value.length > 0) {
            thumbs = value.map(file => {
                const item = {
                    ...file,
                    preview: URL.createObjectURL(file.file),
                };
                return (
                    <Grid key={item.file.name} item xs={4}>
                        <div className={classes.imgThumbnail}>
                            <img
                                className={classes.imgThumbnailImg}
                                src={item.preview}
                                alt="preview"
                            />
                            <button
                                className={classes.imgThumbnailBtn}
                                type="button"
                                data-filename={item.file.name}
                                onClick={event => {
                                    this.handleRemove(
                                        event.target.dataset.filename
                                    );
                                }}
                            >
                                x
                            </button>
                        </div>
                    </Grid>
                );
            });
        }

        return (
            <section>
                {error && (
                    <FormHelperText className="error__message">
                        {error}
                    </FormHelperText>
                )}
                {stateError && (
                    <FormHelperText className="error__message">
                        {stateError}
                    </FormHelperText>
                )}
                <Dropzone
                    maxSize={2500000}
                    accept="image/*"
                    onDrop={this.handleChange}
                >
                    {({ getRootProps, getInputProps }) => (
                        <div
                            className={classes.dropzoneContainer}
                            {...getRootProps()}
                        >
                            <input {...getInputProps()} />
                            <Typography variant="body1">
                                Cliquer ou glisser-déposer des images ici
                            </Typography>
                            <p className={classes.dropzone} />
                        </div>
                    )}
                </Dropzone>
                <aside>
                    <Grid container alignItems="center" spacing={12}>
                        {thumbs}
                    </Grid>
                    <ul>
                        {rejected &&
                            rejected.map(f => (
                                <li key={f.name} className="error__message">
                                    <FormHelperText className="error__message">
                                        {`Impossible d'ajouter le fichier ${f.name}.`}
                                        {
                                            " La taille maximale autorisée est 2.5Mo."
                                        }
                                        {` Taille du fichier: ${Number(
                                            f.size / 1000000
                                        ).toFixed(1)} Mo`}
                                    </FormHelperText>
                                </li>
                            ))}
                    </ul>
                </aside>
            </section>
        );
    }
}

export default withStyles(styles)(DropzoneWithPreview);
